<script setup>
defineProps({
  date: {
    type: String,
    required: true,
  },
});
</script>

<template>
  <time>{{ new Date(date).toLocaleString('nb-NO', {year:'numeric', month:'long', day:'2-digit', hour:'numeric', minute:'numeric'}) }}</time>
</template>
